<template>
  <div class="weui_cell" :class="{'weui_select_after':title, 'weui_cell_select':!readonly}">
    <div class="weui_cell_hd" v-if="title" :class="{'weui_cell_primary':readonly}">
      <label for="" class="weui_label" :style="{width: $parent.labelWidth +'rem', textAlign: $parent.labelAlign, marginRight: $parent.labelMarginRight}">{{title}}</label>
    </div>
    <div class="weui_cell_bd weui_cell_primary" v-if="!readonly">
      <select class="weui_select" :class="classes" :name="name" v-model="currentValue" :style="{direction: direction}">
        <option value="" v-if="placeholder" :selected="placeholder && !currentValue">{{placeholder}}</option>
        <option :value="one.key" v-for="one in processOptions">{{one.value}}</option>
      </select>
    </div>
    <div class="weui_cell_ft" v-else>
      {{currentValue | findByKey(processOptions)}}
    </div>
  </div>
</template>

<script>
import find from 'array-find'

const findByKey = function (key, options) {
  const _rs = find(options, function (item) {
    return item.key === key
  })
  return _rs ? _rs.value : key
}

export default {
  computed: {
    processOptions () {
      if (this.options.length && {}.hasOwnProperty.call(this.options[0], 'key')) {
        return this.options
      } else {
        return this.options.map(function (item) {
          return {
            key: item,
            value: item
          }
        })
      }
    },
    classes () {
      return {
        'vux-selector-no-padding': !this.title,
        'cvux-selector-placeholder': this.currentValue === ''
      }
    }
  },
  filters: {
    findByKey
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (newValue) {
      this.currentValue = newValue
    },
    currentValue (newValue) {
      this.$emit('input', newValue)
      this.$emit('on-change', newValue)
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: {
      type: [String, Number, Boolean],
      default: ''
    }
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_access';
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
@import '../../styles/cui/widget/cui_cell/cui_form/cui_form_common';
@import '../../styles/cui/widget/cui_cell/cui_form/cui_select_after';
.vux-selector-no-padding {
  padding-left: 0;
}
.cvux-selector-placeholder {
  color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// selector.vue?56bf20f3